export default "__VITE_ASSET__914a8d6a__"